// extracted by mini-css-extract-plugin
module.exports = {"prescription_slider":"styles_prescription_slider__N4Vaw","next":"styles_next__KNK6H","previous":"styles_previous__RrhsO"};